import { nsStr } from '../../../../../services/lib/utils/helpers'

/**
 * Maps WorkOrder/GetTrackingInfo rows to table rows.
 * Product/GetAllProductName only returns active products, so for discontinued
 * products the lookup misses - fall back to the fields carried by the row
 * itself instead of leaving the cells blank.
 */
export const mapTrackingRows = (data: any, products: any[], stockMonitorProductId?: any) => {
  const findProductById = (id: number) => {
    const product = products.find((product: any) => product.productId === id)
    return product || null
  }

  const renderData: any = []
  data.map((row: any) => {
    if (row.workOrderStatusId !== 0) {
      const product = findProductById(row.productId)
      const productCode = product?.productCode ?? row.productCode
      const productName = product?.productName ?? row.productName
      row.product = product
      const newData = {
        ...row,
        actionId: row.actionDto?.actionId,
        urgent: row.urgent ? 1 : 0,
        productCode: productCode,
        productFilter: productName + nsStr(productName),
        createdEmployeeName: (row.createdEmployee?.firstName || '') + ' ' + (row.createdEmployee?.lastName || ''),
        createdAt1: row.createdAt,
        requiredDate1: row.requiredDate,
        createdAt: row.createdAt && (new Date(row.createdAt + '.000Z')).toLocaleString(),
        requiredDate: row.requiredDate && (new Date(row.requiredDate + '.000Z')).toLocaleDateString(),
        workOrderNo: row.workOrderNo && parseInt(row.workOrderNo),
        workOrderStatusId1: row.workOrderStatusId == 2 ? 1 : row.workOrderStatusId,
      }
      if (stockMonitorProductId) {
        if (row.productId === stockMonitorProductId) {
          renderData.push(newData)
        }
      } else {
        renderData.push(newData)
      }
    }
  })
  return renderData
}
